import { motion } from "framer-motion";

// Professional success animation — drawing circle + check.
export default function SuccessCheck({ title, message, children }) {
  return (
    <div className="flex flex-col items-center py-10 text-center" data-testid="form-success">
      <motion.svg
        viewBox="0 0 96 96"
        className="h-20 w-20"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <motion.circle
          cx="48"
          cy="48"
          r="42"
          fill="none"
          stroke="#10B981"
          strokeWidth="4"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        />
        <motion.path
          d="M30 50 L43 63 L67 35"
          fill="none"
          stroke="#34D399"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.5, delay: 0.55, ease: "easeOut" }}
        />
      </motion.svg>
      <h3 className="mt-6 font-display text-2xl font-bold uppercase tracking-wide text-ink">{title}</h3>
      <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-500">{message}</p>
      {children}
    </div>
  );
}
